import type { NavigationItem } from '@command-center/core-platform';
import type { RouteTitle } from '@command-center/ui-system';
import { adminConfig } from './config';

export type { RouteTitle };

const ROUTE_TITLE_FALLBACK: RouteTitle = { title: adminConfig.clientName || 'One Up' };

/**
 * Look up the page title + subtitle for a pathname. Performs an exact match
 * first, then a prefix match (so /tasks/abc123 still resolves to "Tasks").
 */
export function getRouteTitle(pathname: string): RouteTitle {
  const exact = adminConfig.navigation.find((item) => item.route === pathname);
  if (exact) return toRouteTitle(exact);

  const candidates = [...adminConfig.navigation].sort((a, b) => b.route.length - a.route.length);
  const prefix = candidates.find(
    (item) => item.route !== '/' && pathname.startsWith(`${item.route}/`),
  );
  if (prefix) return toRouteTitle(prefix);

  return ROUTE_TITLE_FALLBACK;
}

export function getModuleForRoute(route: string): NavigationItem | undefined {
  return adminConfig.navigation.find((item) => item.route === route);
}

function toRouteTitle(item: NavigationItem): RouteTitle {
  return { title: item.label, sub: item.description };
}
